<template>
  <div
    class="relative flex min-h-[280px] items-center justify-center rounded-xl px-10 py-[64px] sm:px-6 sm:pb-6 sm:pt-[50px]"
    :class="[
      step.isDisabled ? 'opacity-60' : 'z-10',
      mode === 'dark'
        ? 'bg-dark-sidebar'
        : 'border border-border-10 bg-white-100',
    ]"
  >
    <div>
      <span
        class="absolute left-1/2 top-0 flex h-[28px] w-[99px] -translate-x-1/2 transform items-center justify-center rounded-bl rounded-br bg-opacity-50 text-[12px] font-semibold"
        :class="[
          mode === 'dark'
            ? 'bg-dark-border text-white-100'
            : 'bg-black-10 text-black-80',
        ]"
        >Step {{ step.number }}</span
      >
      <div class="text-center">
        <h2 class="mb-3 text-[22px] font-semibold sm:text-[18px]">
          {{ step.title }}
        </h2>
        <p
          class="text-[14px] font-medium"
          :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
        >
          {{ step.description }}
        </p>
        <div
          v-if="step.isForExample"
          @click="showExample"
          class="mt-4 flex cursor-pointer items-center justify-center gap-2 text-center text-[14px] font-semibold leading-none text-primary-100"
        >
          <span>Example:</span>
          <CircleHelp :size="18" :stroke-width="1.75" />
        </div>
      </div>
    </div>
    <template v-if="step.isForExample">
      <div
        v-if="isExample"
        class="absolute left-3 right-3 top-[215px] z-10 sm:top-[195px]"
      >
        <div
          class="divide-y rounded-lg border"
          :class="[
            mode === 'dark'
              ? 'divide-dark-border border-dark-border bg-dark-body'
              : 'divide-border-10 border-border-10 bg-black-10',
          ]"
        >
          <div
            class="grid grid-cols-5 divide-x"
            :class="[
              mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
            ]"
          >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Model</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Mfg</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Quantity</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Price</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Offer</span
            >
          </div>
          <div
            v-for="(i, key) in 3"
            :key="key"
            class="grid grid-cols-5 divide-x"
            :class="[
              mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
            ]"
          >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >9406</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >IBM</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >2</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >$300 each</span
            >
            <span
              class="py-2 text-center text-[12px] font-medium"
              :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
              >Sell</span
            >
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CircleHelp } from "lucide-vue-next";

export default {
  name: "Step",
  props: {
    mode: String,
    step: {
      type: Object,
      default: {
        number: "",
        title: "",
        description: "",
        isDisabled: false,
        isForExample: false,
      },
    },
  },
  components: {
    CircleHelp,
  },
  data() {
    return {
      isExample: false,
    };
  },
  methods: {
    showExample() {
      this.isExample = !this.isExample;
      this.$emit("isExample", this.isExample);
    },
  },
};
</script>
